/* Warranty categories with keyboard navigation and shareable tab links. */
(() => {
  'use strict';
  const hashes = {
    'gaming-pc': '#warranty-plans',
    accessories: '#warranty-accessories',
    components: '#warranty-components',
  };

  function initialize(scope = document) {
    scope.querySelectorAll('[data-elite-warranty-tabs]').forEach(root => {
      if (root.dataset.warrantyTabsReady) return;
      const tablist = root.querySelector('[data-warranty-tablist]');
      const tabs = [...root.querySelectorAll('[data-warranty-tab]')];
      const panels = [...root.querySelectorAll('[data-warranty-panel]')];
      if (!tablist || tabs.length !== 3 || panels.length !== 3) return;
      root.dataset.warrantyTabsReady = 'true';

      function select(key, { focus = false, updateUrl = false } = {}) {
        const active = tabs.find(tab => tab.dataset.warrantyTab === key);
        if (!active) return;
        tabs.forEach(tab => {
          const selected = tab === active;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(panel => {
          panel.hidden = panel.dataset.warrantyPanel !== key;
        });
        if (focus) active.focus();
        if (updateUrl && location.hash !== hashes[key]) {
          const url = new URL(location.href);
          url.hash = hashes[key];
          history.replaceState(history.state, '', url);
        }
      }

      function selectFromHash() {
        const key = Object.keys(hashes).find(key => hashes[key] === location.hash)
          || (location.hash === '#warranty-gaming-pc' ? 'gaming-pc' : null);
        if (key) select(key);
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab.dataset.warrantyTab, { updateUrl: true }));
        tab.addEventListener('keydown', event => {
          let nextIndex;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;
          event.preventDefault();
          select(tabs[nextIndex].dataset.warrantyTab, { focus: true, updateUrl: true });
        });
      });
      select('gaming-pc');
      selectFromHash();
      tablist.hidden = false;
      window.addEventListener('hashchange', selectFromHash);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
